export enum AlertListDirection {
  Vertical = 'vertical',
  Horizontal = 'horizontal'
}
